import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { Crown, Check } from "lucide-react";
import { toast } from "sonner";
import PayPalCheckout from "../components/PayPalCheckout";

const PERKS = [
  "Early access to every drop",
  "10% off all merch — always",
  "Members-only funny videos",
  "Cousin Cletus priority chat",
  "Free shipping on US orders $35+",
  "Exclusive VIP sticker every month",
];

export default function Subscribe({ onAuthRequired }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    api.get("/subscription/plans").then((r) => setPlans(r.data));
  }, []);

  const plan = plans[0];

  const handleSuccess = (data) => {
    nav(`/payment-success?order_id=${data.order_id}`);
  };

  return (
    <div className="min-h-screen max-w-5xl mx-auto px-4 md:px-8 py-12 md:py-20" data-testid="subscribe-page">
      <div className="text-center mb-12">
        <div className="font-anton uppercase tracking-[0.3em] text-[#DD5422] text-sm mb-2">/ Inner Circle</div>
        <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tight">Become VIP</h1>
        <p className="text-[#8D9688] mt-4 max-w-2xl mx-auto">Where the loud get louder. Members get drops first, discounts always, and the wild stuff we don't show the public.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-[#151A14] border-2 border-[#2C332A] p-8" data-testid="free-tier-card">
          <div className="font-anton uppercase tracking-[0.3em] text-[#8D9688] text-sm">Free</div>
          <h2 className="font-anton text-4xl uppercase tracking-tight mt-2">Tailgater</h2>
          <div className="font-anton text-5xl mt-4">$0<span className="text-base text-[#8D9688]">/forever</span></div>
          <ul className="space-y-3 mt-8">
            {["Browse the full shop", "Public funny videos", "Ask Cousin Cletus 3 questions/day", "Standard checkout"].map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-[#E5E5E5]">
                <Check className="w-5 h-5 text-[#4B5320] flex-shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
          <Button disabled className="w-full mt-8 bg-[#2C332A] text-[#8D9688] rounded-none font-anton uppercase tracking-widest h-12 border-2 border-[#2C332A]">
            Current Plan
          </Button>
        </div>

        <div className="relative border-2 border-[#DD5422] p-8 bg-[#151A14]" data-testid="vip-tier-card">
          <div className="absolute -top-3 left-8 bg-[#DD5422] text-[#0A0E0B] px-3 py-1 font-anton uppercase tracking-widest text-xs">
            ★ Most Popular
          </div>
          <Crown className="w-8 h-8 text-[#DD5422]" />
          <div className="font-anton uppercase tracking-[0.3em] text-[#DD5422] text-sm mt-2">VIP</div>
          <h2 className="font-anton text-4xl uppercase tracking-tight mt-1">Redneck Royalty</h2>
          <div className="font-anton text-5xl mt-4 text-[#DD5422]">
            ${plan?.amount?.toFixed(2) ?? "9.99"}<span className="text-base text-[#8D9688]">/{plan?.interval ?? "month"}</span>
          </div>
          <ul className="space-y-3 mt-8">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-[#E5E5E5]">
                <Check className="w-5 h-5 text-[#DD5422] flex-shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
          {user?.is_subscriber ? (
            <Button disabled data-testid="already-vip-btn" className="w-full mt-8 bg-[#4B5320] text-[#E5E5E5] rounded-none font-anton uppercase tracking-widest h-12 border-2 border-[#4B5320]">
              ✓ You're VIP
            </Button>
          ) : !user ? (
            <Button data-testid="signin-to-subscribe-btn" onClick={() => { onAuthRequired?.(); toast.info("Sign in to subscribe"); }}
              className="w-full mt-8 bg-[#DD5422] text-[#0A0E0B] hover:bg-[#FF6B35] rounded-none font-anton uppercase tracking-widest h-12 border-2 border-[#DD5422]">
              Sign In to Subscribe
            </Button>
          ) : (
            <div className="mt-8" data-testid="vip-paypal-container">
              <PayPalCheckout
                type="subscription"
                payload={{ plan_id: plan?.id || "vip_monthly", origin_url: window.location.origin }}
                disabled={!plan}
                onSuccess={handleSuccess}
              />
            </div>
          )}
          <div className="text-xs text-[#8D9688] mt-3 uppercase tracking-widest text-center">Cancel anytime · Secure via PayPal</div>
        </div>
      </div>
    </div>
  );
}
